import SSCartesian from './sscartesian';
import LineDataset from '../_internal/datasets/line';
import { HUNDREDSTRING, preDefStr } from '../_internal/lib/lib';
let UNDEF,
  SEVENTYSTRING = preDefStr.SEVENTYSTRING;
class Line extends SSCartesian {
  /**
   * Provides the name of the chart extension
   *
   * @static
   * @return {string} The name of the chart extension
   */
  static getName () {
    return 'Line';
  }

  constructor () {
    super();

    this.defaultPlotShadow = 1;
    this.axisPaddingLeft = 0;
    this.axisPaddingRight = 0;
  }
  /**
   * Sets the name of the component
   * @return {string} name
   */
  getName () {
    return 'Line';
  }
  __setDefaultConfig () {
    super.__setDefaultConfig();
    let config = this.config;
    config.friendlyName = 'Line Chart';
    config.singleseries = true;
    config.defaultDatasetType = 'line';
    config.anchorborderthickness = 1;
    config.anchorimageurl = UNDEF;
    config.anchorimagepadding = 1;
    config.anchorsides = 1;
    config.anchoralpha = UNDEF;
    config.anchorbgalpha = HUNDREDSTRING;
    config.anchorimagealpha = HUNDREDSTRING;
    config.anchorimagescale = 100;
    config.anchorstartangle = 90;
    config.anchorshadow = 0;
    config.anchorbgcolor = UNDEF;
    config.anchorbordercolor = UNDEF;
    config.anchorradius = 3;
    config.showvalues = 1;
    config.plotfillalpha = SEVENTYSTRING;
    config.linedashlen = 5;
    config.linedashgap = 4;
    config.linedashed = UNDEF;
    config.linealpha = HUNDREDSTRING;
    config.linethickness = 2;
    config.drawfullareaborder = 1;
    config.connectnulldata = 0;
    config.zeroplanethickness = 1;
    config.enablemousetracking = true;
    config.zeroplanealpha = 40;
    config.showzeroplaneontop = 0;
    config.defaultcrosslinethickness = 1;
  }
  // This method return the dataset definations for this charts
  getDSdef () {
    return LineDataset;
  }
  // // This method return the dataset-group definations for this charts
  // getDSGroupdef (name) {
  //   return UNDEF;
  // }
}
export default Line;
